import { IAgentState } from "@/core/interfaces/state/agentState.interface";

const agentState: IAgentState = {
  organization_users: [],
  isFetchingAgents: false,
  organization_agents: [],
  isFetchingOrganizationUsers: false,
  isFetchingAgent: false,
  organization_user: null,
  isUpdatingAgentPermissions: false,
  agentPricingResponse: null,
  organizationAgentsPaginationMeta: null,
};

export default agentState;
